import { render, staticRenderFns } from "./DepartmentBalance.vue?vue&type=template&id=0b4a3304&scoped=true"
import script from "./DepartmentBalance.vue?vue&type=script&lang=js"
export * from "./DepartmentBalance.vue?vue&type=script&lang=js"
import style0 from "./DepartmentBalance.vue?vue&type=style&index=0&id=0b4a3304&prod&scoped=true&lang=css"
import style1 from "./DepartmentBalance.vue?vue&type=style&index=1&id=0b4a3304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4a3304",
  null
  
)

export default component.exports